import { Box, Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import Global from '../../../customlib/Global';

class TeleDiChatOlehCustomerResponseTimeReportFirstTimeMobile extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"First Respon Di Chat Customer"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Box>
                        {this.props.state.contactLeads?.map(lead => {
                            return (
                            <Box elevation={2} sx={{mb: "5px", padding: "5px"}}>
                                <Grid container spacing={1}>
                                    <Grid item xs={8}>
                                        <strong>{lead.salesName}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        <strong>AVG : {Global.formatTime(lead.avgResponseTime < 0 ? 0 : lead.avgResponseTime)}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"left"}>
                                        Leads<br />
                                        <strong>{lead.leads.length}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"center"}>
                                        &lt; 1 Menit<br />
                                        <strong>{lead.totalUnderOneMinute}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        &gt; 1 Menit<br />
                                        <strong>{lead.totalHigherOneMinute}</strong>
                                    </Grid>
                                    
                                </Grid>
                                <Divider sx={{mt: "8px"}} />
                            </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default TeleDiChatOlehCustomerResponseTimeReportFirstTimeMobile;